"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Fragment = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _preact = require("preact");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Fragment polyfill for Preact 8.
 *
 * Preact 8 has no built-in Fragment support. This component acts as a
 * transparent wrapper: single children are returned directly (no extra
 * DOM node), multiple children are wrapped in a <span> because Preact 8
 * requires a single root VNode from render().
 *
 * Used via babel pragmaFrag + webpack ProvidePlugin so that JSX fragment
 * syntax (<>…</>) works out of the box.
 */
var Fragment = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Fragment, _Component);

  var _super = _createSuper(Fragment);

  function Fragment() {
    (0, _classCallCheck2.default)(this, Fragment);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(Fragment, [{
    key: "render",
    value: function render() {
      var children = this.props.children;

      if (Array.isArray(children) && children.length === 1) {
        return children[0];
      }

      return children;
    }
  }]);
  return Fragment;
}(_preact.Component);

exports.Fragment = Fragment;
var _default = Fragment;
exports.default = _default;